import { Any } from './Any';
import { Boolean } from './Boolean';
import { DateInterval } from './DateInterval';
import { DateTime } from './DateTime';
import { Float } from './Float';
import { Int } from './Int';
import { Json } from './Json';
import { String } from './String';

export { Any, String, DateTime, Float, Int, Boolean, Json, DateInterval };

export const any = Any;
export const string = String;
export const datetime = DateTime;
export const date = DateTime;
export const time = DateTime;
export const float = Float;
export const double = Float;
export const real = Float;
export const int = Int;
export const integer = Int;
export const boolean = Boolean;
export const bool = Boolean;
export const json = Json;
export const JSON = Json;
export const dateinterval = DateInterval;
export const dateInterval = DateInterval;
